import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { login } from '../../Redux/Actions/authActions';

const Login = ({ onLogin, location, auth }) => {
  const [redirectToReferrer, setRedirect] = useState(false);
  const [username, setUser] = useState('');
  const [password, setPw] = useState('');

  const { from } = location.state || { from: { pathname: '/' } };

  const submit = () => {
    axios
      .post('api/v1/auth', { username, password })
      .then(resp => resp.data)
      .then(data => {
        onLogin(data);
        setRedirect(true);
      })
      .catch(e => {
        toast.error(`L'utilisateur et le mot de passe ne concordent pas`);
      });
  };

  if (auth.isAuthenticated === true) {
    switch (auth.user.userType) {
      case 'captain':
        return <Redirect to={'/dispatch'} />;
      default:
        return <Redirect to={'/'} />;
    }
  }

  if (redirectToReferrer === true) {
    return <Redirect to={from} />;
  }

  return (
    <div className="main bg-color">
      <div className="center-vertical">
        <div className="center-content">
          <div className="login-container center-margin">
            <div className="content-box">
              <h3 className="content-box-header content-box-header-alt bg-default">
                <span className="icon-separator">
                  <i className="fa fa-cogs" />
                </span>
                <span className="header-wrapper">
                  Espace Membre
                  <small>Connectez-vous à votre compte.</small>
                </span>
              </h3>
              <div className="content-box-wrapper">
                <div className="form-group">
                  <div className="input-group">
                    <input
                      autoFocus="autofocus"
                      className="form-control"
                      placeholder="Utilisateur"
                      type="text"
                      name="user"
                      autoComplete="off"
                      value={username}
                      onChange={e => setUser(e.target.value)}
                      onKeyDown={e => e.key === 'Enter' && submit()}
                    />
                    <span className="input-group-addon bg-blue">
                      <i className="fa fa-envelope-o" />
                    </span>
                  </div>
                </div>

                <div className="form-group">
                  <div className="input-group">
                    <input
                      autoComplete="off"
                      className="form-control"
                      placeholder="Mot de passe"
                      type="password"
                      name="password"
                      value={password}
                      onChange={e => setPw(e.target.value)}
                      onKeyDown={e => e.key === 'Enter' && submit()}
                    />
                    <span className="input-group-addon bg-blue">
                      <i className="fa fa-unlock-alt" />
                    </span>
                  </div>
                </div>
                {/* <div className="field">
                  <input
                    type="checkbox"
                    value={remember}
                    name="remember_me"
                    id="remember_me"
                    onChange={e => setRemember(e.target.checked)}
                  />
                  <label htmlFor="remember_me">Remember me</label>
                </div> */}

                <div className="actions">
                  <input
                    type="submit"
                    name="commit"
                    value="Connexion"
                    className="btn btn-success btn-block"
                    id="login-button"
                    onClick={submit}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Login.defaultProps = {
  auth: {},
};

const mapStateToProps = state => ({
  auth: state.auth,
});

const mapDispatchToProps = dispatch => ({
  onLogin: data => dispatch(login(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);
